import LeadForm from "../components/sections/LeadForm";
import SectionHeader from "../components/ui/SectionHeader";

function ContactPage() {
  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Kontakt" title="Napis mi k zakazce">
          Posli kratky popis prace a kontakt. Ozvu se s dalsim postupem nebo terminem prohlidky.
        </SectionHeader>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
          <LeadForm />
          <aside className="card p-6">
            <h2 className="text-xl font-bold text-white">Kontakt</h2>
            <div className="mt-5 space-y-4 text-sm leading-6 text-slate-300">
              <p>
                <span className="block font-semibold text-white">Telefon</span>
                +420 123 456 789
              </p>
              <p>
                <span className="block font-semibold text-white">E-mail</span>
                info@eltt.cz
              </p>
              <p>
                <span className="block font-semibold text-white">Oblast</span>
                Karlovarsky kraj a okoli
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
